import { Zodiac } from '../api';

// Canonical editorial slugs from landing/content/sun-*.topic.json.
const slugs: Record<Zodiac, Record<'pt' | 'en' | 'es' | 'fr', string>> = {
  Aries: { pt: 'sol-em-carneiro', en: 'sun-in-aries', es: 'sol-en-aries', fr: 'soleil-en-belier' },
  Taurus: { pt: 'sol-em-touro', en: 'sun-in-taurus', es: 'sol-en-tauro', fr: 'soleil-en-taureau' },
  Gemini: { pt: 'sol-em-gemeos', en: 'sun-in-gemini', es: 'sol-en-geminis', fr: 'soleil-en-gemeaux' },
  Cancer: { pt: 'sol-em-caranguejo', en: 'sun-in-cancer', es: 'sol-en-cancer', fr: 'soleil-en-cancer' },
  Leo: { pt: 'sol-em-leao', en: 'sun-in-leo', es: 'sol-en-leo', fr: 'soleil-en-lion' },
  Virgo: { pt: 'sol-em-virgem', en: 'sun-in-virgo', es: 'sol-en-virgo', fr: 'soleil-en-vierge' },
  Libra: { pt: 'sol-em-balanca', en: 'sun-in-libra', es: 'sol-en-libra', fr: 'soleil-en-balance' },
  Scorpio: { pt: 'sol-em-escorpiao', en: 'sun-in-scorpio', es: 'sol-en-escorpio', fr: 'soleil-en-scorpion' },
  Sagittarius: { pt: 'sol-em-sagitario', en: 'sun-in-sagittarius', es: 'sol-en-sagitario', fr: 'soleil-en-sagittaire' },
  Capricorn: { pt: 'sol-em-capricornio', en: 'sun-in-capricorn', es: 'sol-en-capricornio', fr: 'soleil-en-capricorne' },
  Aquarius: { pt: 'sol-em-aquario', en: 'sun-in-aquarius', es: 'sol-en-acuario', fr: 'soleil-en-verseau' },
  Pisces: { pt: 'sol-em-peixes', en: 'sun-in-pisces', es: 'sol-en-piscis', fr: 'soleil-en-poissons' },
};

export function sunGuideUrl(sign: Zodiac | undefined, language: string): string | undefined {
  if (!sign || !slugs[sign]) return undefined;
  const baseLanguage = language.toLowerCase().split('-')[0];
  const locale = baseLanguage === 'en' || baseLanguage === 'es' || baseLanguage === 'fr' ? baseLanguage : 'pt';
  const section = locale === 'en' ? 'astrology' : locale === 'fr' ? 'astrologie' : 'astrologia';
  return `https://senti.pt/${locale}/${section}/${slugs[sign][locale]}/` +
    '?utm_source=senti&utm_medium=free-tool&utm_campaign=gr006-mapa-gratis&utm_content=sun-guide';
}
